import ReactPlayer from 'react-player';

function SafetyVideo() {
  return (
    <div className="safetyvideo__container">
      <div className="safetyvideo__wrapper">
        <ReactPlayer
          url="https://vimeo.com/460348144"
          width="1170"
          controls={true}
        />
      </div>
      <div className="safetyvideo__safeguard column">
        <div className="safetyvideo__title">
          <h1>해양 생물 자원에 대한 보호</h1>
        </div>
        <div className="safetyvideo__content">
          <p>
            귀중한 자원에 대한 지속 가능한 관리는 마오리족의 카이티아키탕가, 즉
            보호자정신의 개념으로 이 산업의 핵심입니다. 이는 사람이 바다와 함께
            일하는 지침을 주고, 그 보상은 다음 세대를 위해 보존되는 것을
            뜻합니다.{' '}
          </p>
          <p>
            <b>
              저희는 항상 해양 환경에 미치는 영향을 최소화하기 위해 노력하고
              있습니다.
            </b>
          </p>
        </div>
      </div>
    </div>
  );
}

export default SafetyVideo;
